<template>
  <section class="honor-container" ref="container">
    <!-- Capa de destellos animados -->
    <div class="sparkles-canvas" ref="sparkles"></div>

    <div class="honor-content">
      <section class="honor-group">
        <div class="title-line" ref="line"></div>
        <br>
        <p class="honor-subtitle" ref="sub"> Mis Padrinos</p>

        <div class="padrinos-list">
                    <p class="honor-text name">Dulce y Mario Rivas</p>

          <p class="honor-text name">Cynthia y Roberto Rivas</p>
          <p class="honor-text name">George y Rebeca Ontiveros</p>
          <p class="honor-text name">Daniel y Ulysses Ontiveros</p>
          <p class="honor-text name">Maricela Haro</p>
          <p class="honor-text name">Elena Fernández</p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import gsap from 'gsap';

export default {
  name: 'CuadroDeHonor',
  mounted() {
    this.initAnimations();
    this.createSparkles();
  },
  methods: {
    initAnimations() {
      const tl = gsap.timeline({ delay: 0.5 });

      tl.from(this.$refs.label, { y: -20, opacity: 0, duration: 1 })
        .from(this.$refs.line, { width: 0, duration: 0.8 }, "-=0.5")
        .from(this.$refs.sub, { scale: 0.8, opacity: 0, duration: 0.8 }, "-=0.3")
        .from(".name", { 
          y: 20, 
          opacity: 0, 
          stagger: 0.2, 
          duration: 1, 
          ease: "power2.out" 
        }, "-=0.5");
    },
    createSparkles() {
      const container = this.$refs.sparkles;
      for (let i = 0; i < 25; i++) {
        const sparkle = document.createElement('div');
        sparkle.className = 'sparkle-dot';
        container.appendChild(sparkle);

        // Posición aleatoria
        gsap.set(sparkle, {
          x: Math.random() * window.innerWidth,
          y: Math.random() * 400,
          scale: Math.random() * 1.5
        });

        // Animación infinita de destello
        gsap.to(sparkle, {
          opacity: Math.random(),
          duration: Math.random() * 1.5 + 0.5,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut"
        });

        // Movimiento flotante
        gsap.to(sparkle, {
          y: "-=30",
          x: "+=20",
          duration: Math.random() * 3 + 2,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut"
        });
      }
    }
  }
}
</script>

<style scoped>
.honor-container {
  width: 100%;
  max-width: 1100px;
  margin: 20px auto;
  padding: 60px 18px;
  /* Degradado elegante */
  background: radial-gradient(circle at center, #9fcbe2 0%, #7ca2da 100%);
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.sparkles-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

:deep(.sparkle-dot) {
  position: absolute;
  width: 4px;
  height: 4px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 10px #fff, 0 0 15px #d4af37; /* Brillo dorado/blanco */
}

.honor-content {
  position: relative;
  z-index: 2;
  max-width: 780px;
  margin: 0 auto;
  text-align: center;
}

.title-line {
  width: 100px;
  height: 2px;
  margin: 10px auto 20px;
  background: linear-gradient(90deg, transparent, #fff, transparent);
}

.label {
  font-family: 'quote', serif;
  font-weight: 400;
  letter-spacing: .2em;
  text-transform: uppercase;
  font-size: 16px;
  color: rgba(255,255,255,0.8);
  margin: 0;
}

.honor-subtitle {
  font-family: 'quote', serif;
  font-size: 42px;
  color: #fff;
  margin-bottom: 30px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.padrinos-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.name {
  font-family: 'quote', serif;
  font-size: 29px !important; /* Más grande y elegante */
  color: #ffffff;
  line-height: 1.9 !important;
  margin: 0;
  font-weight: 300;
  transition: transform 0.3s;
}

.name:hover {
  transform: scale(1.05);
  color: #f3f3f3;
}

@media (max-width: 768px) {
  .honor-subtitle { font-size: 32px; }
  .name { font-size: 20px; }
}
</style>